import React, { useEffect, useState, useContext } from "react";
import "./sidebar.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { baseRequest } from "../../../axiosconfig";
import { ROLES } from "../../../constants/roles";
import { UnsavedDataContext } from "../../../context";
import { UserContext } from "../../../userContext";
import GlobalSearch from "../globalSearch";

function Sidebar({ isLoggedin, setIsloggedin, setLoading }) {
  const { user, setUser } = useContext(UserContext);

  function handleLogout() {
    setLoading(true);
    baseRequest
      .post("/logout", {})
      .then((res) => {
        setUser(null);
        navigate("/login");
        setIsloggedin(false);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }

  const showItem = (user) => {
    return user.role_id === ROLES.SUPER_ADMIN;
  };

  const { unsavedData, setShowNavigatePopup, setNavigateUrl } =
    useContext(UnsavedDataContext);

  const items = [
    {
      id: 1,
      name: "OBAVEŠTENJA",
      icon: "/images/bell.png",
      iconActive: "/images/bellactive.png",
      url: "/admin/notifications",
    },
    {
      id: 2,
      name: "fuk",
      icon: "/images/fuk.png",
      iconActive: "/images/fukactive.png",
      url: "/admin/fuk",
      multiple: true,
      items: [
        { id: 7, name: "FUK početna strana", url: "/admin/fuk" },
        {
          id: 1,
          name: "Liste poslovnih procesa",
          url: "/admin/poslovni-procesi",
        },
        { id: 2, name: "Mape procesa", url: "/admin/mape-procesa" },
        { id: 3, name: "Formulari rizika", url: "/admin/formulari-rizika" },
        { id: 4, name: "Registri rizika", url: "/admin/registri-rizika" },
        {
          id: 5,
          name: "Registar kontrolnih aktivnosti",
          url: "/admin/registar-kontrola",
        },
        { id: 6, name: "Akcioni planovi", url: "/admin/akcioni-planovi" },
      ],
    },
    {
      id: 6,
      name: "IZVEŠTAJI",
      icon: "/images/fuk.png",
      iconActive: "/images/fukactive.png",
      multiple: true,
      items: [
        { id: 1, name: "Upitnik za samoprocenu", url: "/admin/samoprocena" },
        {
          id: 2,
          name: "Godišnji izveštaj o sistemu FUK",
          url: "/admin/godisnji-izvestaj",
        },
        { id: 3, name: "Izveštaji po zahtevu", url: "/admin/izvestaji" },
      ],
    },
    {
      id: 3,
      name: "organizacija",
      icon: "/images/globe1.png",
      iconActive: "/images/globe1active.png",
      multiple: true,
      items: [
        {
          id: 1,
          name: "Struktura preduzeća",
          url: "/admin/struktura-preduzeca",
        },
        { id: 2, name: "Lista zaposlenih", url: "/admin/lista-zaposlenih/0/0" },
      ],
    },
    {
      id: 4,
      name: "arhiva",
      icon: "/images/arhiv.png",
      iconActive: "/images/arhivactive.png",
      multiple: true,
      items: [
        {
          id: 1,
          name: "Liste poslovnih procesa",
          url: "/admin/archive-poslovni-procesi",
        },
        { id: 2, name: "Mape procesa", url: "/admin/archive-mape-procesa" },
        { id: 3, name: "Formulari rizika", url: "/admin/archive-formulari-rizika" },
        { id: 4, name: "Lista arhiviranih zaposlenih", url: "/admin/archive-zaposleni" },
      ],
    },
    {
      id: 5,
      name: "PODEŠAVANJA",
      icon: "/images/settings.png",
      iconActive: "/images/settingsactive.png",
      multiple: true,
      items: [
        {
          id: 1,
          name: "Autorizacija",
          url: "/admin/autorizacija",
          show: showItem(user),
        },
        {
          id: 4,
          name: "Evidencija aktivnosti",
          url: "/admin/aktivnosti",
          show: showItem(user),
        },
        { id: 5, name: "Promena lozinke", url: "/admin/promena-lozinke" },
        { id: 2, name: "Kontaktirajte nas", url: "/admin/contact" },
        { id: 3, name: "Odjavite se", onClick: true },
      ],
    },
  ];
  const [activeNavigationItem, setActiveNavigationItem] = useState("");
  const [activeUrl, setActiveUrl] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let url = location.pathname;

    if (location.pathname === "/admin/notifications") {
      setActiveUrl("/admin/notifications");
      setActiveNavigationItem("OBAVEŠTENJA");
      return;
    }

    // Sidebar je u layout ruti pa useParams ne vidi parametre child ruta;
    // aktivna stavka se izvodi iz same putanje: skida se "new" segment
    // (/admin/mape-procesa/new → /admin/mape-procesa) i numerički ID-jevi
    // sa kraja (/admin/samoprocena/3 → /admin/samoprocena).
    if (url.includes("/mape-procesa/new")) {
      url = "/admin/mape-procesa";
    } else if (url === "/admin/formulari-rizika/new") {
      url = "/admin/formulari-rizika";
    } else {
      url = url.replace(/(\/\d+)+$/, "");
    }
    if (url === "/admin/lista-zaposlenih") {
      url = "/admin/lista-zaposlenih/0/0";
    }

    setActiveUrl(url);

    const value = items.find((el) => {
      return el.multiple && el.items.find((it) => it.url === url);
    });
    if (value) {
      setActiveNavigationItem(value.name);
    }
  }, [location]);

  const handleClick = (item) => {
    if (!item.multiple) {
      navigate(item.url);
      setActiveNavigationItem(item.name);
    } else {
      setActiveNavigationItem((value) => {
        if (item.name === value) {
          return "";
        } else {
          return item.name;
        }
      });
    }
  };

  return (
    <div>
      <ul className="sidebar">
        <GlobalSearch />
        {items.map((item) => {
          return (
            <div
              key={item.id}
              className={
                item.name === activeNavigationItem
                  ? "sidebar-navigation-item sidebar-navigation-item-active"
                  : "sidebar-navigation-item"
              }
            >
              <div
                // to={item.url}
                onClick={() => handleClick(item)}
                className={
                  item.name === activeNavigationItem
                    ? "sidebar-navigation-item-link sidebar-navigation-item-link-active"
                    : "sidebar-navigation-item-link"
                }
                style={{
                  borderBottom:
                    item.multiple && item.name === activeNavigationItem
                      ? "1px solid var(--mainColor)"
                      : "none",
                }}
              >
                <div className="flex-center">
                  <img
                    alt="icon"
                    src={
                      item.name === activeNavigationItem
                        ? item.iconActive
                        : item.icon
                    }
                    className={
                      item.name === activeNavigationItem
                        ? "sidebar-navigation-item-icon sidebar-navigation-link-active"
                        : "sidebar-navigation-item-icon"
                    }
                  ></img>
                  <span> {item.name}</span>
                </div>

                {item.multiple && (
                  <img
                    alt="icon"
                    src="/images/sidebararrow.png"
                    className={
                      item.name === activeNavigationItem
                        ? "sidebar-navigation-item-arrow sidebar-navigation-item-arrow-open"
                        : "sidebar-navigation-item-arrow"
                    }
                  ></img>
                )}
              </div>

              {item.multiple && item.name === activeNavigationItem && (
                <ul className="sidebar-navigation-subitems-list">
                  {item?.items &&
                    item.items.map((element) => {
                      if (element.show === undefined || element.show)
                        return (
                          <li
                            onClick={
                              element.onClick
                                ? handleLogout
                                : () => {
                                    if (!unsavedData) {
                                      navigate(element.url);
                                    } else if (
                                      unsavedData &&
                                      location.pathname !== element.url
                                    ) {
                                      setShowNavigatePopup(true);
                                      setNavigateUrl(element.url);
                                    }
                                  }
                            }
                            key={element.id}
                            className="sidebar-navigation-subitem"
                          >
                            <span
                              style={{
                                borderBottom:
                                  element.url === activeUrl
                                    ? "1px solid var(--mainColor)"
                                    : "none",
                                fontWeight:
                                  element.url === activeUrl ? "bold" : "normal",
                              }}
                            >
                              {element.name}
                            </span>
                          </li>
                        );
                    })}
                </ul>
              )}
            </div>
          );
        })}
      </ul>
    </div>
  );
}

export default Sidebar;
